import router from '@/router/router'
import {setToken} from '@/utils/auth'
import {getUserInfo} from '@/api/system/user'
import {loginByUsername, loginByWechat, logout, loginByShenbao} from '@/api/auth/jwt'
import {getTopMenu} from '@/api/user'
import {getDeptEntity} from "@/api/system/dept";

const actions = {
    setToken({commit}, token) {
        commit('SET_TOKEN', token)
    },
    setUserinfo({getters, dispatch, commit}, userInfo) {
        commit('SET_USERINFO', userInfo)
        let { deptId }= getters.userInfo
        dispatch("LoginUserDept", deptId)
    },
    LoginUserDept({ commit }, deptId){
        if (deptId == null || deptId === "") {
            return
        }

        let deptInfo = {}
        getDeptEntity(deptId).then(res => {
            deptInfo = res
        }).finally(()=>{
            commit('SET_LOGIN_USER_DEPT_INFO', deptInfo)
        })
    },
    // 根据用户名登录
    LoginByUsername({dispatch}, userInfo) {
        return new Promise((resolve, reject) => {
            loginByUsername(userInfo.username, userInfo.password)
                .then(token => {
                    dispatch("LoginSuccess", token)
                        .then(() => resolve())
                        .catch(e => reject(e))
                })
                .catch(err => reject(err))
        })
    },
    LoginByWecat({dispatch}, code) {
        return new Promise((resolve, reject) => {
            loginByWechat(code)
                .then(token => {
                    dispatch("LoginSuccess", token)
                        .then(() => resolve())
                        .catch(e => reject(e))
                })
                .catch(err => reject(err))
        })
    },
    LoginSuccess({commit, dispatch}, token) {
        return new Promise((resolve, reject) => {
            dispatch('setToken', token, {root: true})
            dispatch('setUserinfo', null, { root: true })
            commit('DEL_ALL_TAG')
            commit('CLEAR_LOCK')
            if (token) {
                setToken(token)
                dispatch('common/setLoginVisible', false, {root: true})
                // dispatch('common/setQuestionTypeList', null, { root: true })
                dispatch('GetUserInfo', null, {root: true})
                    .then(info => {
                        resolve({
                            ...info,
                            token
                        })
                    })
                    .catch(() => {
                        reject(new Error('获取用户信息失败'))
                    })
            } else {
                reject(new Error('登录失败'))
            }
        })
    },
    // 实验空间登录
    LoginByShenbao({dispatch}, {shenbaoId, username, pass}) {
        return new Promise((resolve, reject) => {
            loginByShenbao(shenbaoId, username, pass)
                .then(token => {
                    return dispatch('LoginSuccess', token)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    GetUserInfo({dispatch}) {
        return new Promise((resolve, reject) => {
            getUserInfo()
                .then(userInfo => {
                    dispatch('setUserinfo', userInfo, {root: true})
                    resolve(userInfo)
                })
                .catch(err => reject(err))
        })
    },
    // 登出
    LogOut({dispatch}) {
        logout()
            .then(() => {
                dispatch('FedLogOut', null, {root: true})
            })
            .catch(() => {
            })
    },
    shenbaoLogOut({dispatch}, key) {
        logout().then(() => {
            dispatch('setToken', '', {root: true})
            dispatch('common/setCurrentExpInfo', key, {root: true})
            router.push({path: `/edu/${key}`})
                .then(() => {
                    // then
                })
        }).catch(() => {
        })
    },
    // 注销session
    FedLogOut({commit, dispatch}) {
        dispatch('setToken', '', {root: true})
        commit('SET_MENU', [])
        dispatch('common/setCurrentExpInfo', null, {root: true})
        // dispatch('common/setQuestionTypeList', null, { root: true })
        router.push({path: '/'})
            .then(() => {
                // do something
            })
    },
    // 跳转404并注销
    Fed404LogOut({commit, dispatch}) {
        dispatch('setToken', '', {root: true})
        commit('SET_MENU', [])
        dispatch('common/setCurrentExpInfo', null, {root: true})
        // dispatch('common/setQuestionTypeList', null, { root: true })
        router.push({name: 'views404'})
            .then(() => {
                // then
            })
    },
    GetTopMenu() {
        return new Promise((resolve, reject) => {
            getTopMenu().then((menus = []) => {
                resolve(menus)
            }).catch(error => {
                reject(error)
            })
        })
    },
}

export default actions
